export default __webpack_public_path__ + "static/media/pic3.4745a7d8.jpg";